import React from 'react';

import { ICategory } from '@Hotels-at-Home/hah-fe-core/dist/types/category';
import { useTranslation } from 'next-i18next';
import { sanitizeHtml } from '@Hotels-at-Home/hah-fe-core/dist/utils';

interface IProps {
  category: ICategory;
}
const feelWellNames = [
  'White Tea',
  'Robes',
  'Towels',
  'White Tea Bath & Body',
  'Bath & Spa',
  'White Tea Fragrance',
];

const CategoryHeader = ({ category }: IProps) => {
  const { t } = useTranslation('', { keyPrefix: '$local' });

  const isFeelWell = feelWellNames.includes(category.name_en.category_name);
  const imgSrc = `/images/misc/${isFeelWell ? 'feel' : 'sleep'}-well-icon.svg`;
  const catalog = isFeelWell ? t('feelWell') : t('sleepWell');
  return (
    <div id="category-header" className="item ctg-header">
      <div className="category-image-wrapper">
        <img src={imgSrc} alt={category.name} />
        <p className="catalog-title">{catalog}</p>
      </div>
      <div className="stack">
        <h1 className="name">
          <span>{category.name}</span>
        </h1>
        <div
          className="description"
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(category.description) }}
        />
      </div>
    </div>
  );
};

export default CategoryHeader;
